import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type MaintenanceModuleSpecsFragment } from '../../../../api/fragments/MaintenanceModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

export type MaintenanceModuleActionsProps = {
    module: MaintenanceModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const MaintenanceModuleActions = ({ module, permissions }: MaintenanceModuleActionsProps) => {
    const { t } = useTranslation(['maintenance', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('maintenance:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('maintenance:mainActionButtons.actions')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default MaintenanceModuleActions;
